import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";

import { Loading } from "../components/Atoms/Loading";

interface IPerfisFormatedProps {
  recursos: string[];
  roles: string[];
}

type ContextSite = {
  isLoad: boolean;
  setIsLoad: Dispatch<SetStateAction<boolean>>;
  tokenContext: string;
  setTokenContext: (e: string) => void;
  perfis: IPerfisFormatedProps;
  setPerfis: Dispatch<SetStateAction<IPerfisFormatedProps>>;
};

type Props = {
  children: ReactNode;
};

export const Context = createContext({} as ContextSite);

export function ContextProvider({ children }: Props) {
  const [isLoad, setIsLoad] = useState(false);
  const [tokenContext, setTokenContext] = useState("");
  const [perfis, setPerfis] = useState<IPerfisFormatedProps>(
    {} as IPerfisFormatedProps
  );

  return (
    <Context.Provider
      value={{
        isLoad,
        setIsLoad,
        tokenContext,
        setTokenContext,
        perfis,
        setPerfis,
      }}
    >
      {children}
      {isLoad && <Loading />}
    </Context.Provider>
  );
}

export function useContextSite() {
  const contextSite = useContext(Context);
  return contextSite;
}
